import editorialData from "@/data/editorial.json";

/**
 * Contenu éditorial d'une fiche lieu — rédigé à partir de sources officielles
 * recoupées (traçabilité : data/editorial-sources.json). Règle absolue :
 * aucune information inventée ; un champ absent n'est pas affiché.
 */
export type EditorialContent = {
  /** Titre d'affichage corrigé (le titre legacy reste intact dans scenes.json) */
  displayTitle?: string;
  /**
   * Commune vérifiée. Les « communes » de l'inventaire viennent des groupes
   * Panotour et sont parfois fausses (ex. « Volcan »). null = ne pas afficher.
   */
  commune?: string | null;
  /** 30-50 mots — catalogue, carte, aperçus */
  shortDescription: string;
  /** 60-100 mots */
  intro: string;
  /** 250-400 mots, en paragraphes */
  mainDescription: string[];
  /** Ce que la visite virtuelle permet d'observer */
  panorama360: string;
  /** Uniquement des informations vérifiées ; tout champ absent est omis du rendu */
  usefulInfo?: Partial<{
    altitude: string;
    acces: string;
    periodeConseillee: string;
    conseils: string;
    environnement: string;
    protection: string;
  }>;
  seo: {
    title: string;
    metaDescription: string;
    ogDescription: string;
  };
};

const editorial = editorialData as Record<string, EditorialContent>;

export function getEditorial(slug: string): EditorialContent | undefined {
  return editorial[slug];
}

/** Titre d'affichage : correction éditoriale si présente, sinon titre legacy */
export function displayTitle(scene: { slug: string; title: string }): string {
  return editorial[scene.slug]?.displayTitle ?? scene.title;
}

/** Commune d'affichage : correction éditoriale (null = masquée), sinon inventaire */
export function displayCommune(scene: { slug: string; commune?: string }): string | undefined {
  const e = editorial[scene.slug];
  if (e && "commune" in e) return e.commune ?? undefined;
  return scene.commune;
}

/** Libellés d'affichage des informations utiles (ordre de rendu) */
export const usefulInfoLabels: Array<[keyof NonNullable<EditorialContent["usefulInfo"]>, string]> =
  [
    ["altitude", "Altitude"],
    ["acces", "Accès"],
    ["periodeConseillee", "Période conseillée"],
    ["conseils", "Conseils"],
    ["environnement", "Environnement"],
    ["protection", "Protection du site"],
  ];
